import React from 'react';
import HandoverItemTypeDropdown from '../../shared/common-dropdown/HandoverItemTypeDropdown';

function EditHandoverItems({ HandoverItemsData, sendDataToParent }) {
    function handleChange(e) {
        const { name, value } = e.currentTarget;
        sendDataToParent({
            ...HandoverItemsData,
            [name]: value,
        });
    }

    const handleTypeChange = (option) => {
        sendDataToParent({
            ...HandoverItemsData,
            HandoverItemType: option ? option.label : '',
        });
    };

    return (
        <>
            <div className="row">
                <div className="mb-3">
                    <input
                        type="hidden"
                        name="HandoverItemId"
                        value={HandoverItemsData.HandoverItemId ?? ''}
                    />
                    <HandoverItemTypeDropdown
                        showTitle
                        required
                        value={HandoverItemsData.HandoverItemType}
                        onChangeDropdown={handleTypeChange}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">
                        Handover Item Title<span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        name="HandoverItemTitle"
                        value={HandoverItemsData.HandoverItemTitle ?? ''}
                        onChange={handleChange}
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                        className="form-control h-100"
                        rows="2"
                        name="Description"
                        value={HandoverItemsData.Description ?? ''}
                        onChange={handleChange}
                    />
                </div>
            </div>
        </>
    );
}

export default EditHandoverItems;
